export const messages = {
    "shared-link.footer.link.install": "Testen Sie {brandName} kostenlos",
    "shared-link.footer.link.mobile": "{brandName} für Mobilgeräte",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Geschützte Daten",
    "shared-link.password-dialog-box.message": "Spezifizieren Sie das Kennwort, um auf die freigegebenen Daten zugreifen zu können",
    "shared-link.password-dialog-box.hint.password": "Kennwort",
    "shared-link.password-dialog-box.message.invalid-password": "Das Kennwort ist falsch",
    "shared-link.form.button.open": "Öffnen",
    "shared-link.page-not-found.title": "Die Seite wurde nicht gefunden",
    "shared-link.page-not-found.message.main": "Die von Ihnen gesuchte Seite konnte nicht gefunden werden.",
    "shared-link.page-not-found.message.description": "Entweder ist der Link veraltet oder Sie haben die Adresse falsch eingegeben.",
    "shared-link.page-not-found.message.error": "Fehlercode: 404",
    "shared-link.restore-file.label.size": "Größe",
    "shared-link.restore-file.button.restore": "Download",
    "shared-link.links-table.column.name": "Name",
    "shared-link.links-table.column.size": "Größe",
    "shared-link.links-table.action.restore": "Download",
    "shared-link.links-table.action.restore-all": "Alle herunterladen",
    "shared-link.side-bar.selected.title:plural": "{count} Elemente ausgewählt | {count} Element ausgewählt | {count} Elemente ausgewählt",
    "shared-link.links-table.label.size": "Größe",
    "shared-link.links-table.message.empty-folder": "Dieser Ordner ist leer"
};
